"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var UserStore_1 = require("../stores/UserStore");
var NavState_1 = require("../contexts/NavState");
var logo_white_svg_1 = __importDefault(require("res/img/logo-white.svg"));
var logo_icon_svg_1 = __importDefault(require("res/img/logo-icon.svg"));
var clients_icon_svg_1 = __importDefault(require("res/img/clients-icon.svg"));
var clients_icon_yellow_svg_1 = __importDefault(require("res/img/clients-icon-yellow.svg"));
var gantt_icon_svg_1 = __importDefault(require("res/img/gantt-icon.svg"));
var gantt_icon_yellow_svg_1 = __importDefault(require("res/img/gantt-icon-yellow.svg"));
var user_management_icon_svg_1 = __importDefault(require("res/img/user-management-icon.svg"));
var user_management_icon_yellow_svg_1 = __importDefault(require("res/img/user-management-icon-yellow.svg"));
var settings_icon_svg_1 = __importDefault(require("res/img/settings-icon.svg"));
var settings_icon_yellow_svg_1 = __importDefault(require("res/img/settings-icon-yellow.svg"));
var help_icon_svg_1 = __importDefault(require("res/img/help-icon.svg"));
var open_in_new_icon_svg_1 = __importDefault(require("res/img/open-in-new-icon.svg"));
var Nav = function (_a) {
    var collapsed = _a.collapsed, onCollapseToggle = _a.onCollapseToggle, userRoles = _a.userRoles;
    var _b = react_1.useState(false), helpOpen = _b[0], setHelpOpen = _b[1];
    var _c = react_1.useState(false), animationFlag = _c[0], setAnimationFlag = _c[1];
    var initialCollapsed = react_1.useState(collapsed)[0];
    var location = react_router_dom_1.useLocation();
    var pathname = location.pathname;
    react_1.useEffect(function () {
        if (collapsed !== initialCollapsed)
            setAnimationFlag(true);
    }, [collapsed]);
    react_1.useEffect(function () {
        if (helpOpen)
            document.addEventListener('click', clickHandler);
        return function () { return document.removeEventListener('click', clickHandler); };
    }, [helpOpen]);
    var clickHandler = function (e) {
        var target = e.target;
        if (target.closest('.nav__help-menu'))
            return;
        setHelpOpen(false);
    };
    return (react_1.default.createElement("nav", { className: "nav flex flex-column", "data-animation-flag": animationFlag, "data-collapsed": collapsed === NavState_1.NavState.COLLAPSED },
        react_1.default.createElement("div", { className: "nav__logo-space flex flex-column flex-center" },
            react_1.default.createElement("img", { src: collapsed === NavState_1.NavState.COLLAPSED ? logo_icon_svg_1.default : logo_white_svg_1.default, alt: "RWD" })),
        react_1.default.createElement("div", { className: "nav__menu flex flex-column" },
            react_1.default.createElement(react_router_dom_1.NavLink, { to: "/gantt-chart", title: "Gantt Chart", className: "nav__menu__item flex flex-row" },
                react_1.default.createElement("img", { src: pathname === '/gantt-chart' && gantt_icon_yellow_svg_1.default || gantt_icon_svg_1.default, alt: 'Gantt Chart' }),
                react_1.default.createElement("span", null, "Gantt Chart")),
            react_1.default.createElement(react_router_dom_1.NavLink, { to: "/clients", title: "Clients", className: "nav__menu__item flex flex-row" },
                react_1.default.createElement("img", { src: pathname === '/clients' && clients_icon_yellow_svg_1.default || clients_icon_svg_1.default, alt: 'Clients' }),
                react_1.default.createElement("span", null, "Clients")),
            userRoles.includes(UserStore_1.UserRoles.ADMIN) &&
                react_1.default.createElement(react_router_dom_1.NavLink, { to: '/users', title: 'Users', className: 'nav__menu__item flex flex-row' },
                    react_1.default.createElement("img", { src: pathname === '/users' && user_management_icon_yellow_svg_1.default || user_management_icon_svg_1.default, alt: 'User Management' }),
                    react_1.default.createElement("span", null, "User Management")),
            react_1.default.createElement(react_router_dom_1.NavLink, { to: "/settings", title: "Settings", className: "nav__menu__item flex flex-row" },
                react_1.default.createElement("img", { src: pathname === '/settings' && settings_icon_yellow_svg_1.default || settings_icon_svg_1.default, alt: 'Settings' }),
                react_1.default.createElement("span", null, "Settings")),
            react_1.default.createElement("div", { className: 'nav__help-menu' },
                react_1.default.createElement("button", { title: 'Open Help Menu', "aria-label": 'Open Help Menu', onClick: function () { return setHelpOpen(!helpOpen); }, className: 'nav_help-menu__icon nav__menu__item flex flex-row' },
                    react_1.default.createElement("img", { src: help_icon_svg_1.default, alt: 'Help Icon' }),
                    react_1.default.createElement("span", null, "Help & Support")),
                helpOpen &&
                    react_1.default.createElement("div", { className: 'nav__help-menu__menu flex flex-column', role: 'menu' },
                        react_1.default.createElement("span", { className: 'title' }, "Help"),
                        react_1.default.createElement("ul", null,
                            react_1.default.createElement("li", null,
                                react_1.default.createElement("a", { href: '#', className: 'flex flex-row', title: 'What\'s new', target: '_blank', rel: 'noreferrer' },
                                    react_1.default.createElement("span", null, "What's new"),
                                    react_1.default.createElement("img", { src: open_in_new_icon_svg_1.default, alt: 'Open in new tab' }))),
                            react_1.default.createElement("li", null,
                                react_1.default.createElement("a", { href: '#', className: 'flex flex-row', title: 'Documentation', target: '_blank', rel: 'noreferrer' },
                                    react_1.default.createElement("span", null, "Documentation"),
                                    react_1.default.createElement("img", { src: open_in_new_icon_svg_1.default, alt: 'Open in new tab' })))),
                        react_1.default.createElement("span", { className: 'title' }, "Support"),
                        react_1.default.createElement("ul", null,
                            react_1.default.createElement("li", null,
                                react_1.default.createElement("a", { href: '#', className: 'flex flex-row', title: 'Contact Support', target: '_blank', rel: 'noreferrer' },
                                    react_1.default.createElement("span", null, "Contact Support"),
                                    react_1.default.createElement("img", { src: open_in_new_icon_svg_1.default, alt: 'Open in new tab' })))),
                        react_1.default.createElement("span", { className: 'title' }, "Legal"),
                        react_1.default.createElement("ul", null,
                            react_1.default.createElement("li", null,
                                react_1.default.createElement("a", { href: '#', className: 'flex flex-row', title: 'Privacy Policy', target: '_blank', rel: 'noreferrer' },
                                    react_1.default.createElement("span", null, "Privacy Policy"))),
                            react_1.default.createElement("li", null,
                                react_1.default.createElement("a", { href: '#', className: 'flex flex-row', title: 'Privacy Policy', target: '_blank', rel: 'noreferrer' },
                                    react_1.default.createElement("span", null, "Terms of Service"))))))),
        react_1.default.createElement("div", { className: "nav__collapse-toggle flex flex-column flex-center", onClick: onCollapseToggle },
            react_1.default.createElement("div", { className: "nav__collapse-toggle__icon" }))));
};
exports.default = Nav;
